module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BoldItalic.cb8c24c.eot";